import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { apiMain } from "@/common/services";
import { IStreamateCamera } from "@/common/services/types";
import { getCameras } from "@/common/utils/streamate";
import { mainBus } from "@/common/buses";

interface IProps {
  tags: string[];
}

export const useStreamateCamera = ({ tags }: IProps) => {
  const [isSound, setSound] = useState(false);
  const [camera, setCamera] = useState<IStreamateCamera | null>(null);
  const [isError, setError] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleClick = useCallback(() => {
    if (camera === null) {
      console.debug("Camera not loaded, cannot handle click.");
      return;
    }

    console.debug(`Opening camera ${camera.nickname} in new tab.`);

    window.open(camera.url, "_blank");
  }, [camera]);

  const fetchCamera = useMemo(() => async () => {
    try {
      console.debug("Fetching Streamate camera...");

      const response = await apiMain.getStreamateCamera({
        tags,
        exclude: getCameras(),
      });

      console.debug(`Loaded Streamate camera ${response.nickname}.`);
      mainBus.emit("add_streamate_camera", response.id);

      setCamera(response);
    } catch (e) {
      console.error("Error fetching camera:", e);
      setError(true);
    }
  }, []);

  const handleToggleSound = useCallback(() => {
    setSound(prev => !prev);
  }, []);

  useEffect(() => {
    fetchCamera();
  }, []);

  return { camera, handleClick, isError, handleToggleSound, isSound, videoRef };
};
